<template>
  <div
    class="tool-bar position-fixed bg-white shadow rounded p-3 d-flex align-items-center flex-nowrap"
    style="bottom: 16px; right: 16px"
  >
    <div class="">
      <i
        v-b-popover.hover.top="$t('workflowDesigner.toggleMap')"
        class="fal fa-map icon-xl cursor-pointer"
        :class="{ 'text-primary': toolbarOptions.showMap }"
        @click="$emit('toggle-map')"
      />
    </div>
    <div class="">
      <i
        v-b-popover.hover.top="$t('workflowDesigner.centerView')"
        class="fal fa-bullseye icon-xl cursor-pointer"
        @click="$emit('center-view')"
      />
    </div>
    <v-divider vertical />
    <div class="">
      <i
        v-b-popover.hover.top="$t('workflowDesigner.zoomOut')"
        class="fal fa-magnifying-glass-minus icon-xl cursor-pointer"
        :class="{ 'is-disabled': toolbarOptions.scale.toFixed(1) <= 0.6 }"
        @click="$emit('zoom', -0.2)"
      />
    </div>
    <div class="font-size-xs">
      {{ Math.round(toolbarOptions.scale * 100) }}%
    </div>
    <div class="">
      <i
        v-b-popover.hover.top="$t('workflowDesigner.zoomIn')"
        class="fal fa-magnifying-glass-plus icon-xl cursor-pointer"
        :class="{ 'is-disabled': toolbarOptions.scale.toFixed(1) >= 2 }"
        @click="$emit('zoom', 0.2)"
      />
    </div>
    <v-divider vertical />
    <div>
      <i
        v-b-popover.hover.top="$t('workflowDesigner.clearWorkflow')"
        class="fal fa-trash icon-xl cursor-pointer"
        @click="$emit('clear-all')"
      />
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: ["toolbarOptions"],
  data() {
    return {};
  },
  mounted() {},
  methods: {}
};
</script>

<style lang="scss">
.tool-bar {
  > * {
    margin-left: 5px;
    margin-right: 5px;
  }
  i {
    &:not(.is-disabled):hover {
      color: #ff3554 !important;
    }
    &.is-disabled {
      cursor: default !important;
      opacity: 0.6;
    }
  }
}
</style>
